import {Component, Inject, Input} from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  constructor(public dialogRef: MdDialogRef<ConfirmationDialogComponent>,
              @Inject(MD_DIALOG_DATA) public data: DialogData) { }
}

interface DialogData {
  message: string;
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-renderer/components/confirmation-dialog/confirmation-dialog.component.ts